// One light/dark choice for the whole app.
//
// The login page used to read its own "login-theme" key while the admin layout read "admin-theme",
// and the admin header's switch only wrote "admin-theme" — so the two drifted apart, and a choice
// made on one page reached the other only after a reload. Both keys are still written so a tab
// running the previous bundle keeps reading the right value; "admin-theme" is the one read first.
//
// A change in one tab is pushed to every other open tab through the `storage` event, which the
// browser fires only in the tabs that did NOT make the change — the tab that did applies it itself.
const KEY = "admin-theme";
const LEGACY_KEY = "login-theme";

export function storedDark() {
  const value = localStorage.getItem(KEY) || localStorage.getItem(LEGACY_KEY);
  return value === "dark";
}

// Vuetify's flag paints its own components; the class on <html> is what the global dark styles in
// App.vue and the pages key off.
export function applyTheme(vm, dark) {
  vm.$vuetify.theme.dark = dark;
  document.documentElement.classList.toggle("theme--dark", dark);
}

export function saveTheme(dark) {
  const value = dark ? "dark" : "light";
  localStorage.setItem(KEY, value);
  localStorage.setItem(LEGACY_KEY, value);
}

// Calls `callback(dark)` whenever another tab changes the theme. Returns the unsubscribe function.
export function onThemeChange(callback) {
  const handler = (event) => {
    if (event.key === KEY && event.newValue) callback(event.newValue === "dark");
  };
  window.addEventListener("storage", handler);
  return () => window.removeEventListener("storage", handler);
}
